import { useState, useCallback, useRef, useEffect } from "react";

export function useSensitiveAccess() {
  const [sensitiveToken, setSensitiveToken] = useState(null);
  const timerRef = useRef(null);

  const revokeAccess = useCallback(() => {
    setSensitiveToken(null);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const grantAccess = useCallback((token, expiresIn) => {
    setSensitiveToken(token);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(revokeAccess, expiresIn * 1000);
  }, [revokeAccess]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return {
    sensitiveToken,
    isVerified: !!sensitiveToken,
    grantAccess,
    revokeAccess,
  };
}
